var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReactivate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1531_5813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 6.03156L10.59 17.4516L6.35 13.2116L7.76 11.8016L10.59 14.6316L20.59 4.63156L22 6.03156ZM12 20.8516C7.59 20.8516 4 17.2616 4 12.8516C4 8.44156 7.59 4.85156 12 4.85156C13.57 4.85156 15.04 5.31156 16.28 6.10156L17.73 4.65156C16.1 3.52156 14.13 2.85156 12 2.85156C6.48 2.85156 2 7.33156 2 12.8516C2 18.3716 6.48 22.8516 12 22.8516C13.73 22.8516 15.36 22.4116 16.78 21.6316L15.28 20.1316C14.28 20.5916 13.17 20.8516 12 20.8516ZM19 15.8516H16V17.8516H19V20.8516H21V17.8516H24V15.8516H21V12.8516H19V15.8516Z",
    fill: "#0D6000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1531_5813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.851562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactivate);
export default __webpack_public_path__ + "static/media/reactivate.7c7f8a16307f00a6f7541c1b2331ec28.svg";
export { ForwardRef as ReactComponent };